import * as React from 'react';
import type { SVGProps } from 'react';
const SvgCheckmark = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="currentColor"
    viewBox="0 0 20 20"
    {...props}
  >
    <path
      fillRule="evenodd"
      d="m8.53 14.248-.53-.53-.53.53a.75.75 0 0 0 1.06 0M8 12.657l-3.47-3.47a.75.75 0 0 0-1.06 1.06l4 4 .53-.53.53.53 7.718-7.717a.75.75 0 0 0-1.06-1.06z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgCheckmark;
